/* Style claim markers in theme copy and dynamically loaded product text. */
(() => {
  const styleMarkers = (root) => {
    const paragraphs = root.nodeType === 1 && root.matches('p') ? [root] : [];
    if (root.querySelectorAll) paragraphs.push(...root.querySelectorAll('p'));
    paragraphs.forEach(p => {
      if (/^[\s†‡]*(?:These statements|This statement) (?:have|has) not been evaluated by the Food and Drug Administration\./i.test(p.textContent || '')) p.classList.add('vmd-section-disclaimer');
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return /[†‡]/.test(node.data) && !node.parentElement?.closest('script,style,textarea,input,sup,.vmd-disclaimer-marker,svg')
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.data.split(/([†‡])/).forEach(part => {
        if (/^[†‡]$/.test(part)) {
          const sup = document.createElement('sup'); sup.className = 'vmd-disclaimer-marker'; sup.textContent = part; fragment.append(sup);
        } else fragment.append(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  };
  styleMarkers(document.body);
  const observer = new MutationObserver(records => {
    observer.disconnect();
    records.forEach(record => {
      if (record.type === 'characterData' && record.target.parentElement) styleMarkers(record.target.parentElement);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) styleMarkers(node); else if (node.nodeType === 3 && node.parentElement) styleMarkers(node.parentElement); });
    });
    observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  });
  observer.observe(document.body, {childList: true, subtree: true, characterData: true});
})();
